import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CurveService } from '../curve-service/curve.service';
import { LoginService } from '../user-login/login.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { TicketService } from 'src/app/shared/customer/ticket/ticket.service';
import html2canvas from 'html2canvas';
import Canvas2Image from 'canvas2image';
import { MatDialog } from '@angular/material/dialog';

declare var require: any
var XLSX = require("xlsx");

@Component({
    selector: 'app-curve-analyzer',
    templateUrl: './curve-analyzer.component.html',
    styleUrls: ['./curve-analyzer.component.css'],
    standalone: false
})
export class CurveAnalyzerComponent implements OnInit {
  @ViewChild('messageDialog') messageDialog: TemplateRef<any>;
  popupMessage: string = '';

  role: string
  serverErrorMessages: string
  thermalValues: []
  dataPoints: {}
  temperatures: []
  timeArray: []
  derivatives: {}
  firstDerivative: []
  TL: number
  TE_Low: number
  TE_High: number
  T_Sol: number
  graph: {}
  closeResult: string;
  macro: number
  micro: number
  chill: number
  segregation: number
  curveID;
  heatNumber;
  heatId;
  loading: boolean = true
  ticketForm = new FormGroup({
    ticket: new FormControl('')
  })

  keyThermalValuesForm = new FormGroup({
    PouringTemperatureIndex: new FormControl({value:'', disabled:true}),
    PouringTemperature: new FormControl({value:'', disabled:true}),
    LiquidusTemperatureIndex: new FormControl({value:'', disabled:true}),
    LiquidusTemperature: new FormControl({value:'', disabled:true}),
    TELowIndex: new FormControl({value:'', disabled:true}),
    TELow: new FormControl({value:'', disabled:true}),
    TEHighIndex: new FormControl({value:'', disabled:true}),
    TEHigh: new FormControl({value:'', disabled:true}),
    Recalescence: new FormControl({value:'', disabled:true}),
    SolidusTemperatureIndex: new FormControl({value:'', disabled:true}),
    SolidusTemperature: new FormControl({value:'', disabled:true}),
    primaryShrinkage: new FormControl({value:'', disabled:true}),
    primaryExpansion: new FormControl({value:'', disabled:true}),
    secondaryExpansion: new FormControl({value:'', disabled:true}),
    GRF1: new FormControl({value:'', disabled:true}),
    GRF2: new FormControl({value:'', disabled:true}),
    CarbonPercentage: new FormControl({value:'', disabled:true}),
    tegrey: new FormControl({value:'', disabled:true}),
    tewhite: new FormControl({value:'', disabled:true}),
    AlloyTLref: new FormControl({value:'', disabled:true}),
    TESIndex: new FormControl({value:'', disabled:true}),
    TES: new FormControl({value:'', disabled:true}),
    ACEL: new FormControl({value:'', disabled:true}),
    Rigidity: new FormControl({value:'', disabled:true}),
    RigidityIndex: new FormControl({value:'', disabled:true}),
    S1_Area: new FormControl({value:'', disabled:true}),
    S2_Area: new FormControl({value:'', disabled:true}),
    S3_Area: new FormControl({value:'', disabled:true}),
    Firstorder_constant: new FormControl({value:'', disabled:true}),
    Secondorder_constant: new FormControl({value:'', disabled:true}),
    Thirdorder_Constant: new FormControl({value:'', disabled:true}),
    TotalSolidification: new FormControl({value:'', disabled:true}),
  })

  curveData: {}
  file: File;
  exportData : {}

  imageUrl: string | ArrayBuffer = "";
  fileName: string = "No file selected";
  constructor(
    private loginService: LoginService, 
    private router: Router, 
    private curveService: CurveService,
    private modalService: NgbModal,
    private ticketService: TicketService,
    private dialog: MatDialog) {   }

  ngOnInit(): void {
    if (this.loginService.shouldBlock()) {
      alert('Low Balance! Redirecting...');
      this.router.navigateByUrl('/home');
    }
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getCurveData();
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
        }
      )
    }
    else{
      alert('PLEASE LOGIN');
      this.router.navigateByUrl('/signin');
    }
  }

   downloadPage() {

       html2canvas(document.querySelector('.wrapper')).then(function(canvas) {
                document.body.appendChild(canvas);
             return Canvas2Image.saveAsPNG(canvas,200,200);
          });


   }

  onSubmit(){
   //console.log(this.keyThermalValuesForm.getRawValue())
  }

  export(type : string, graph) {
    this.exportData = {};
    this.exportData["Curve ID"] = this.curveData["curveID"];
    this.exportData["Heat Number"] = this.curveData['heatId'];
    this.exportData["Pouring Temperature (PT)"] = this.curveData["thermalValues"]["PouringTemperature"];
    this.exportData["Liquidus Temperature (LT)"] = this.curveData["thermalValues"]["LiquidusTemperature"];
    this.exportData["Start of Eutectic Temperature (SET)"] = this.curveData["thermalValues"]["TES"];
    this.exportData["Lower Eutectic Temperature (LET)"] = this.curveData["thermalValues"]["TELow"];
    this.exportData["Higher Eutectic Temperature (HET)"]  = this.curveData["thermalValues"]["TEHigh"];
    this.exportData["Recalescence (δT)"] = this.curveData["thermalValues"]["Recalescence"];
    this.exportData["Solidus Temperature (ST)"] = this.curveData["thermalValues"]["SolidusTemperature"];
    this.exportData["Primary Shrinkage (PS)"] = this.curveData["thermalValues"]["primaryShrinkage"];
    this.exportData["Primary Expansion (PE)"] = this.curveData["thermalValues"]["primaryExpansion"];
    this.exportData["Secondary Expansion (SE)"] = this.curveData["thermalValues"]["secondaryExpansion"];
    this.exportData["Graphite Factor (Gr.Fact)"] = this.curveData["thermalValues"]["GRF1"];
    this.exportData["Conductivity Factor (CF)"] = this.curveData["thermalValues"]["GRF2"];
    this.exportData["Actual Carbon Equivalent (ACE)"] = this.curveData["thermalValues"]["ACEL"];
    this.exportData["Carbon Percentage (C%)"] = this.curveData["thermalValues"]["CarbonPercentage"];
    this.exportData["Grey Eutectic Temperature (GET)"] = this.curveData["thermalValues"]["TEGrey"];
    this.exportData["White Eutectic Temperature (WET)"] = this.curveData["thermalValues"]["TEWhite"];

    var data = [];
    data[0] = this.exportData;

    if(type == 'XLS')
    {
      const workBook = XLSX.utils.book_new(); // create a new blank book
      const workSheet = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workBook, workSheet, 'data'); // add the worksheet to the book
      XLSX.writeFile(workBook, 'curveData.xlsx');
    } else {
      const replacer = (key, value) => (value === null ? '' : value); // specify how you want to handle null values here
      const header = Object.keys(data[0]);
      const csv = data.map((row) =>
        header
          .map((fieldName) => JSON.stringify(row[fieldName], replacer))
          .join(',')
      );
      csv.unshift(header.join(','));
      const csvArray = csv.join('\r\n');
      const a = document.createElement('a');
      const blob = new Blob([csvArray], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = 'curveData.csv';
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    }
  }

  getCurveData(){
    this.curveService.currentCurve.subscribe(
      curve => {
        this.curveData = curve
        //console.log("--curvedata--")
        //console.log(this.curveData)
        this.curveID = this.curveData['curveID']
        this.heatNumber = this.curveData['heatNumber']
        this.heatId = this.curveData['heatId']
       //console.log('got curve data', this.curveData, this.curveID)
        if(this.role === 'CUSTOMER'){
          if(!this.curveData['paid']){
           //console.log(this.curveData['paid'])
            // window.alert('Please Pay for this curve to view!');
            this.router.navigateByUrl('view-all-graphs')
          }
        this.loading = false;
        }
        this.loading = false;
      }
    )

    if(Object.keys(this.curveData).length === 0){
     //console.log('PLEASE GO BACK')
      // window.alert('Please Select a graph to edit')
      if(this.role === 'CUSTOMER'){
        this.router.navigateByUrl('view-all-graphs')
      }
      if(this.role === 'TECHEXPERT'){
        this.router.navigateByUrl('get-assigned-tickets')
      }
    }
    // this.curveService.getCurveData().subscribe(
    //   res => {
        ////console.log('Got curve data', res['curveDatas'][3]);
        // this.dataPoints = res['curveDatas'][3].dataPoints;
        this.dataPoints = this.curveData['dataPoints']
        this.temperatures = this.dataPoints['temperature']
        this.timeArray = this.dataPoints['timeArray']
        // this.thermalValues = res['curveDatas'][3].thermalValues;
        // this.derivatives = res['curveDatas'][3].derivatives;


        this.thermalValues = this.curveData['thermalValues']
        this.derivatives = this.curveData['derivatives']
        this.firstDerivative = this.derivatives['RefinedFirstDerivative']
        this.macro = this.thermalValues['Macro']
        this.micro = this.thermalValues['Micro']
        this.chill = this.thermalValues['Chill']
        this.segregation = this.thermalValues['Others']

        ////console.log(this.micro, this.macro)
        this.initialiseForm();
        this.TL = this.thermalValues['LiquidusTemperatureIndex'];
        this.TE_Low = this.thermalValues['TELowIndex'];
        this.TE_High = this.thermalValues['TEHighIndex'];
        this.T_Sol = this.thermalValues['SolidusTemperatureIndex'];
        ////console.log(this.temperatures, this.timeArray, this.firstDerivative)
        ////console.log(this.firstDerivative)
    //   },
    //   err => {
    //    //console.log('error getting curve data', err)
    //   }
    // )
  }




  initialiseForm() {

    this.keyThermalValuesForm.get('PouringTemperatureIndex').setValue(this.thermalValues['PouringTemperatureIndex'])
    this.keyThermalValuesForm.get('PouringTemperature').setValue(this.thermalValues['PouringTemperature'].toFixed(0))
    this.keyThermalValuesForm.get('LiquidusTemperatureIndex').setValue(this.thermalValues['LiquidusTemperatureIndex'])
    this.keyThermalValuesForm.get('LiquidusTemperature').setValue(this.thermalValues['LiquidusTemperature'].toFixed(0))
    this.keyThermalValuesForm.get('TELowIndex').setValue(this.thermalValues['TELowIndex'])
    this.keyThermalValuesForm.get('TELow').setValue(this.thermalValues['TELow'].toFixed(0))
    this.keyThermalValuesForm.get('TEHighIndex').setValue(this.thermalValues['TEHighIndex'])
    this.keyThermalValuesForm.get('TEHigh').setValue(this.thermalValues['TEHigh'].toFixed(2))
    this.keyThermalValuesForm.get('Recalescence').setValue(this.thermalValues['Recalescence'].toFixed(1))
    this.keyThermalValuesForm.get('SolidusTemperatureIndex').setValue(this.thermalValues['SolidusTemperatureIndex'])
    this.keyThermalValuesForm.get('SolidusTemperature').setValue(this.thermalValues['SolidusTemperature'].toFixed(0))
    this.keyThermalValuesForm.get('primaryShrinkage').setValue(this.thermalValues['primaryShrinkage'].toFixed(2)+'%')
    this.keyThermalValuesForm.get('primaryExpansion').setValue(this.thermalValues['primaryExpansion'].toFixed(2)+'%')
    this.keyThermalValuesForm.get('secondaryExpansion').setValue(this.thermalValues['secondaryExpansion'].toFixed(2)+'%')
    this.keyThermalValuesForm.get('GRF1').setValue(this.thermalValues['GRF1'].toFixed(0))

    if((this.thermalValues['GRF2']==null) ||  (this.thermalValues['GRF2'] <=0)){
      this.thermalValues['GRF2'] = 1
      alert("GRF2 Value is not correct. Please retake the sample")

    }
    if(this.thermalValues['GRF2'])
    {
      this.keyThermalValuesForm.get('GRF2').setValue(this.thermalValues['GRF2'].toFixed(2))
    }
    else if(this.role == 'TECHEXPERT')
    {
      this.keyThermalValuesForm.get('GRF2').setValue("2")
      alert("GRF2 Value is null, but has been set to 0 for your viewing")
    }
    else
    {
        alert("GRF2 Value is null! please retake the sample.")
        this.router.navigateByUrl('view-all-graphs')
    }

    this.keyThermalValuesForm.get('CarbonPercentage').setValue(this.thermalValues['CarbonPercentage'].toFixed(2))
    this.keyThermalValuesForm.get('tegrey').setValue(this.thermalValues['TEGrey'].toFixed(2))
    this.keyThermalValuesForm.get('tewhite').setValue(this.thermalValues['TEWhite'].toFixed(2))
    this.keyThermalValuesForm.get('AlloyTLref').setValue(this.thermalValues['AlloyTLref'].toFixed(2))
    this.keyThermalValuesForm.get('TESIndex').setValue(this.thermalValues['TESIndex'])
    this.keyThermalValuesForm.get('TES').setValue(this.thermalValues['TES'].toFixed(0))
    this.keyThermalValuesForm.get('ACEL').setValue(this.thermalValues['ACEL'].toFixed(2))
    this.keyThermalValuesForm.get('Rigidity').setValue(this.thermalValues['Rigidity'])
    this.keyThermalValuesForm.get('RigidityIndex').setValue(this.thermalValues['RigidityIndex'])
    this.keyThermalValuesForm.get('S1_Area').setValue(this.thermalValues['S1_Area'])
    this.keyThermalValuesForm.get('S2_Area').setValue(this.thermalValues['S2_Area'])
    this.keyThermalValuesForm.get('S3_Area').setValue(this.thermalValues['S3_Area'])
    this.keyThermalValuesForm.get('Firstorder_constant').setValue(this.thermalValues['Firstorder_constant'])
    this.keyThermalValuesForm.get('Secondorder_constant').setValue(this.thermalValues['Secondorder_constant'])
    this.keyThermalValuesForm.get('Thirdorder_Constant').setValue(this.thermalValues['Thirdorder_Constant'])
    this.keyThermalValuesForm.get('TotalSolidification').setValue(this.thermalValues['TotalSolidification'])

  }

  saveImage(){
    alert('saving image')
  }

  saveValue(){
    alert('saving values')
  }

  getHelp(){
    alert('getting help')
  }


  open(content, graph) {
    ////console.log(content, typeof(content))
    if(this.role =='CUSTOMER')
    {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.graph = graph
     //console.log('got graph', this.graph)
      this.closeResult = `Closed with: ${result}`;
     //console.log(this.closeResult)
      }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
     //console.log(this.closeResult)
        });
    }
    else
    {
      alert('this button is for customers only!');
    }
  }

  getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }


  saveTicket(){
    //console.log(this.ticketForm.get('ticket').value);
     this.ticketService.raiseTicket({message: this.ticketForm.get('ticket').value, curveData: this.curveID, image: this.imageUrl},null).subscribe(
       res => {
        //console.log('Ticket Generated', res);
         alert("Ticket raised successfully! We will reach out to you soon. Thank you for the patience.");
         alert("Responses will be done from 08:30 AM to 05:00 PM on working days");
         // this.router.navigateByUrl('/home');
       },
       err => {
        //console.log('Error generating ticket contact admin', err);
         this.serverErrorMessages = err.error.message
       });
   }

   onChange(file: File) {
    if (file) {
      this.fileName = file.name;
      this.file = file;

      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = event => {
        this.imageUrl = reader.result;
      };
    }
  }
  messageTitle: string = '';
messagePoints: string[] = [];
messageHeaderClass: string = '';

showMessage(message: string): void {
  const lines = message.split('\n');
  const title = lines[0].trim();
  const bulletPoints = lines.slice(1).map(line => line.replace(/^•\s*/, ''));

  this.messageTitle = title;
  this.messagePoints = bulletPoints;

  // Determine class based on title content
  if (title.toUpperCase().includes('LOW RISK')) {
    this.messageHeaderClass = 'message-header low-risk';
  } else if (title.toUpperCase().includes('HIGH RISK')) {
    this.messageHeaderClass = 'message-header high-risk';
  } else {
    this.messageHeaderClass = 'message-header default-header';
  }

  this.dialog.open(this.messageDialog, {
    maxWidth: '1000px',
    maxHeight: '800px',
    panelClass: 'custom-dialog-container',
    disableClose: false
  });
}

}
